import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

const getInformacao = () => {
  let config = {
    method: 'get',
    url: API_URL + 'mensagens',
    responseType: 'json',
    credentials: true
  }
  return Vue.http(config)
}

export default {
  getInformacao
}



// WEBPACK FOOTER //
// ./src/utils/informacao.js